import { render, staticRenderFns } from "./UnsentCurriculumList.vue?vue&type=template&id=501dc1ea&scoped=true&lang=pug"
import script from "./UnsentCurriculumList.vue?vue&type=script&lang=js"
export * from "./UnsentCurriculumList.vue?vue&type=script&lang=js"
import style0 from "./UnsentCurriculumList.vue?vue&type=style&index=0&id=501dc1ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501dc1ea",
  null
  
)

export default component.exports